import { MenuProps } from "antd";
import {
  DashboardOutlined,
  LogoutOutlined,
  TeamOutlined,
  ProjectOutlined,
  SolutionOutlined,
  FileSyncOutlined,
  UserOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

export const getMenuItems = (
  idClient: string,
  idProject: string | null,
  role: "ADMIN" | "USER" | "CLIENT" | "DEMO" | null,
): MenuProps["items"] => {
  const baseItems: MenuProps["items"] = [
    {
      label: "Dashboard",
      key: `/dashboard/${idClient}`,
      icon: <DashboardOutlined className="icon" />,
    },
    {
      label: "Contacts",
      key: `/contacts/${idClient}`,
      icon: <SolutionOutlined className="icon" />,
    },
    {
      label: "Customers",
      key: "customer",
      icon: <TeamOutlined className="icon" />,
      children: [
        {
          label: "All Customer",
          key: `/customer/${idClient}`,
        },
        {
          label: "By Project",
          key: "customer-project",
        },
      ],
    },
    {
      label: "Projects",
      key: "projects",
      icon: <ProjectOutlined className="icon" />,
      children: [
        {
          label: "Projects",
          key: `/project/${idClient}/`,
        },
        {
          label: "Templates",
          key: `/project-template/${idClient}`,
        },
      ],
    },
    {
      label: "File Manager",
      key: `/files/${idClient}`,
      icon: <FileSyncOutlined className="icon" />,
    },
    {
      label: "Reports",
      key: "reports",
      icon: <BarChartOutlined className="icon" />,
      children: [
        {
          label: "Invoiced vs Time",
          key: `/reports/invoiced-vs-time/${idClient}`,
        },
      ],
    },
  ];

  if (role === "ADMIN" || role === "USER") {
    baseItems.push({
      label: "Users",
      key: `/users/${idClient}`,
      icon: <UserOutlined className="icon" />,
    });
  }

  baseItems.push({
    label: "Logout",
    key: "logout",
    icon: <LogoutOutlined />,
  });

  if (role === "CLIENT") {
    return [
      {
        label: "File Manager",
        key: "client-files",
        icon: <FileSyncOutlined className="icon" />,
      },
      {
        label: "Logout",
        key: "logout",
        icon: <LogoutOutlined />,
      },
    ];
  }

  return baseItems;
};
